module.exports = "<router-outlet *ngIf=\"page_not_found==false\"></router-outlet>\n<app-not-found *ngIf=\"page_not_found==true\"></app-not-found>"